module.exports = __webpack_public_path__ + "img/img4.8c29e99b.svg";